module.exports = __webpack_public_path__ + "static/media/FlyerLeft.3c70a18e.png";